import { useEffect, useState } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { ArrowUpRight, Menu, X } from 'lucide-react'
import { creator } from '@/config/creator'
import { SocialIconLink } from './SocialLinks'

const links = [
  { label: 'Newsletter', href: '#newsletter' },
  { label: 'YouTube', href: '#youtube' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
]
const mainPlatforms = ['substack', 'youtube', 'linkedin', 'x']

export default function FounderNav() {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    const query = window.matchMedia('(min-width: 1024px)')
    const closeOnDesktop = () => { if (query.matches) setOpen(false) }
    query.addEventListener('change', closeOnDesktop)
    return () => query.removeEventListener('change', closeOnDesktop)
  }, [])

  return (
    <>
      <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur-xl">
        <div className="creator-container flex h-20 items-center justify-between gap-4">
          <a href="/" aria-label="Danilo Costa — home" className="flex min-h-11 items-center gap-3 font-display text-xl font-bold tracking-tight"><span aria-hidden="true" className="h-3 w-3 rounded-full bg-primary" />{creator.name}<span aria-hidden="true" className="text-primary">↗</span></a>
          <nav aria-label="Main navigation" className="hidden items-center gap-6 lg:flex">
            {links.map(link => <a key={link.href} href={link.href} className="inline-flex min-h-11 items-center text-sm font-medium transition-colors hover:text-primary">{link.label}</a>)}
            <a href={creator.meetingUrl} target="_blank" rel="noopener noreferrer" className="creator-button">Book a call<ArrowUpRight size={17} aria-hidden="true" /></a>
          </nav>
          <Dialog.Root open={open} onOpenChange={setOpen}>
            <Dialog.Trigger asChild><button type="button" aria-label="Open navigation menu" className="flex h-11 w-11 items-center justify-center rounded-full border border-border bg-card lg:hidden"><Menu aria-hidden="true" size={22} /></button></Dialog.Trigger>
            <Dialog.Portal>
              <Dialog.Overlay className="fixed inset-0 z-50 bg-background" />
              <Dialog.Content className="fixed inset-0 z-50 flex flex-col overflow-y-auto bg-background px-6 py-6 sm:px-12">
                <div className="flex items-center justify-between gap-4">
                  <Dialog.Title className="font-display text-xl font-bold">{creator.name}</Dialog.Title>
                  <Dialog.Close asChild><button type="button" aria-label="Close navigation menu" className="flex h-11 w-11 items-center justify-center rounded-full border border-border bg-card"><X aria-hidden="true" size={22} /></button></Dialog.Close>
                </div>
                <Dialog.Description className="sr-only">Explore my writing, videos and story, or book a conversation.</Dialog.Description>
                <nav aria-label="Mobile navigation" className="my-auto flex flex-col gap-3 py-12">
                  {links.map((link, index) => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="creator-display flex min-h-16 items-center gap-5 py-2 text-[clamp(2rem,8vw,3.5rem)] hover:text-primary"><span className="creator-label text-muted-foreground">0{index + 1}</span>{link.label}<ArrowUpRight aria-hidden="true" className="ml-auto h-6 w-6 text-primary" /></a>)}
                  <a href={creator.meetingUrl} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="creator-button mt-6 self-start">Book a call<ArrowUpRight aria-hidden="true" size={18} /></a>
                </nav>
                <p className="creator-label text-muted-foreground">San Francisco / Sicily</p>
              </Dialog.Content>
            </Dialog.Portal>
          </Dialog.Root>
        </div>
      </header>
      <aside aria-label="Quick social links" className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl md:hidden">
        <div className="mx-auto flex max-w-sm items-center justify-around gap-4 px-5">
          {mainPlatforms.map(id => {
            const profile = creator.socials.find(social => social.id === id)
            return profile ? <SocialIconLink key={id} profile={profile} compact /> : null
          })}
        </div>
      </aside>
    </>
  )
}
